import axios from 'axios';
// import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 5000
});

service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    console.error(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.status !== 200) {
      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res;
    }
  },
  error => {
    console.error(error);
    return Promise.reject(error);
  }
);

export default service;
